/**
 * Converts degrees into radians.
 *
 * @param degrees The value to convert into radians.
 *
 * @example deg2rad(180) = Math.PI
 */
export function deg2rad(degrees: number): number {
  return degrees * (Math.PI / 180);
}
